<template>
  <div id="footer" class="footer--container">
    <div class="footer--highlight">
      <div>
        <h1>Ainda não tem aplicativo?</h1>
        <div class="storesButtonsRow">
          <v-btn
            outlined
            tile
            x-large
            color="white"
            href="https://play.google.com/store/apps/details?id=br.com.oi.identidadeoi"
            target="_blank"
          >
            <v-icon size="36" left dark class="mr-4" color="white"
              >mdi-google-play</v-icon
            >
            <div class="buttons--container mt-3">
              <p class="button--title text-uppercase mb-0">Baixe agora</p>
              <p class="button--subtitle">O app está no Google Play</p>
            </div>
          </v-btn>
          <v-btn
            outlined
            tile
            x-large
            color="white"
            href="http://bit.ly/oi-apple"
            target="_blank"
          >
            <v-icon size="36" left dark class="mr-4" color="white"
              >mdi-apple</v-icon
            >
            <div class="buttons--container mt-3">
              <p class="button--title text-uppercase mb-0">Baixe agora</p>
              <p class="button--subtitle">Clique aqui para baixar</p>
            </div>
          </v-btn>
        </div>
      </div>
    </div>
    <div class="footer--content">
      <p class="mb-0">
        Diretoria de Tecnologia, Infraestrutura e Segurança da Informação e
        Cibernética
      </p>
      <p class="mb-0">
        Versão 1.2.0
      </p>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.footer {
  &--container {
    text-align: center;
    color: #fff;
  }

  &--highlight {
    padding: 0px 20px;
    display: flex;
    min-height: 270px;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    background: #00D318;

    &::after {
      display: block;
      content: "";
      min-height: inherit;
      font-size: 0;
    }

    .storesButtonsRow {
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;
      /* justify-content: le; */

      .v-btn:first-child {
        margin-right: 10px;
        margin-bottom: 10px;
      }

      .buttons--container {
        text-align: left;
        color: #fff;
      }
      .button--title {
        font-size: 18px;
        letter-spacing: 2px;
      }
      .button--subtitle {
        font-size: 10px;
        letter-spacing: 0px;
        text-transform: none;
      }
    }

    @media only screen and (max-width: 414px) {
      h1 {
        font-size: 26px;
      }
      .v-btn {
        width: 100%;
      }
      .storesButtonsRow {
        padding: 0px 20px;
      }
    }

    .disableCursor {
      cursor: default;
    }
  }
  &--content {
    display: flex;
    flex-direction: column;
    min-height: 120px;
    padding: 0px 20px;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    background: #545454;

    /* &::after {
      display: block;
      content: "";
      min-height: inherit;
      font-size: 0;
    } */
  }
}
</style>
